import { useRequest } from 'features/request/useRequest';

import { useMemo } from 'react';

import {
    uerRatioUerRowItemsForWorkOrderObjects,
    uerRatioUerRowItemsForWorkOrderRootObject,
} from '../../workOrderUseCoefficientQueries';

interface IRatioUerRowItemsData {
    workOrderObjectIds?: number | number[];
    ratioRowId?: number;
    isRootItem?: boolean;
    isWorkOrderChange?: boolean;
}

export const useRatioUerRowItemsData = (props: IRatioUerRowItemsData) => {
    const { ratioRowId, workOrderObjectIds, isRootItem, isWorkOrderChange } = props;

    const variablesForRootObject = useMemo(
        () => ({
            ratioRowId,
            rootObjectId: workOrderObjectIds,
        }),
        [ratioRowId, workOrderObjectIds],
    );

    const variablesForObjects = useMemo(
        () => ({
            ratioRowId,
            workOrderObjectIds,
        }),
        [ratioRowId, workOrderObjectIds],
    );

    const [ratioRowItemsRootObjectData, ratioRowItemsRootObjectStatus, ,] = useRequest({
        requestId: 'uerRatioUerRowItemsForWorkOrderRootObject',
        query: uerRatioUerRowItemsForWorkOrderRootObject,
        withEffect: isRootItem && !isWorkOrderChange,
        variables: variablesForRootObject,
    });

    const [ratioRowItemsObjectData, ratioRowItemsObjectStatus, ,] = useRequest({
        requestId: 'uerRatioUerRowItemsForWorkOrderObjects',
        query: uerRatioUerRowItemsForWorkOrderObjects,
        withEffect: !isRootItem && !isWorkOrderChange,
        variables: variablesForObjects,
    });

    const rowData = useMemo(
        () =>
            (isRootItem && ratioRowItemsRootObjectData?.uerRatioUerRowItemsForWorkOrderRootObject?.items) ||
            (!isRootItem && ratioRowItemsObjectData?.uerRatioUerRowItemsForWorkOrderObjects?.items) ||
            [],
        [
            isRootItem,
            ratioRowItemsRootObjectData?.uerRatioUerRowItemsForWorkOrderRootObject?.items,
            ratioRowItemsObjectData?.uerRatioUerRowItemsForWorkOrderObjects?.items,
        ],
    );

    const fetchingStatus = useMemo(
        () => (isRootItem && ratioRowItemsRootObjectStatus) || (!isRootItem && ratioRowItemsObjectStatus),
        [isRootItem, ratioRowItemsObjectStatus, ratioRowItemsRootObjectStatus],
    );

    return {
        rowData,
        fetchingStatus,
    };
};
